import React, { useEffect, useState } from 'react'
import { Controller, useFormContext } from 'react-hook-form';
import { Form, Header, Segment } from 'semantic-ui-react';
import { MultipleToggableDropdown } from 'dyl-components';
import { useDispatch, useSelector } from 'react-redux';

import productsActions from 'actions/products';

const AddonApplication = () => {
    const { control } = useFormContext();
    const dispatch = useDispatch();

    const [productOptions, setProductOptions] = useState([]);
    const [search, setSearch] = useState('');

    useEffect(() => {
        dispatch(productsActions.readProducts({ limit: 1000 }));
    }, [dispatch]);

    const { products, categories, category_products, isReadingProducts } = useSelector((state) => {
        return {
            categories: state.products.categories,
            category_products: state.products.category_products,
            products: state.products.products,
            isReadingProducts: state.products.isReadingProducts
        };
    });

    useEffect(() => {
        const categoryOptions = categories.map(category => {
            const categoryProducts = category_products[category.id] || [];
            return {
                key: category.id + "P",
                text: category.name,
                value: category.id + '/P',
                hasOptions: category.has_products,
                options: categoryProducts.map(categoryProduct => ({
                    key: categoryProduct.id,
                    text: categoryProduct.name,
                    value: categoryProduct.id + '/C'
                }))
            };
        });

        const productOptions = products.map(product => ({
            key: product.id + "C",
            text: product.name,
            value: product.id + '/C'
        }))

        setProductOptions([...categoryOptions, ...productOptions]);
    }, [categories, products, category_products]);

    const getCategoryProducts = async (product_category_id) => {
        await dispatch(productsActions.readCategoryProducts({ product_category_id: Number(product_category_id.slice(0, -1)) }));
    }

    const onSearchChange = (e) => {
        setSearch(e.target.value);
    }

    return (
        <Segment className='AddonForm__ProductApplication'>
            <Header as="h3" color="primary">Apply Add-On</Header>
            <Controller
                control={control}
                name='products'
                render={({ field: { name, value, onChange }, fieldState: { error } }) => (
                    <Form.Field
                        control={MultipleToggableDropdown}
                        values={value}
                        nested_options={productOptions}
                        onChange={(_, { value }) => {
                            const splitValue = value[value.length - 1].value.split('/');
                            setSearch('');
                            if (splitValue[1] !== 'P') onChange({ target: { name, value } });
                        }}
                        placeholder='Search product name'
                        onHoverParent={getCategoryProducts}
                        searchValue={search}
                        onSearchChange={onSearchChange}
                        loading={isReadingProducts}
                        selection
                    />
                )}
            />
        </Segment>
    );
}

export default AddonApplication;
